import React from 'react';
import styles from '../css/Main.css';
import Navigation from '../components/Navigation.js';
import photo from '../../design/photos/veroffentlichungen/N4 jausschnitt.jpg';

export default function Veroffentlichungen() {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p className={styles.titleleft}>Hanna Schneider</p>
        <p className={styles.titleright}>Keramik</p>
      </div>
      <div className={styles.content}>
        <div className={styles.textArea}>
          <div>
            <p className={styles.textSmall2}>In den folgenden Büchern wurden meine Arbeiten in</p>
            <p className={styles.textSmall2}>der Neriage-Technik vorgestellt.</p>
          </div>
          <div className={styles.textBlock}>
            <div className={styles.textParagraph}>
              <p className={styles.textBig4}>Color in Clay</p>
              <p className={styles.textSmall1}>by Jane Waller</p>
            </div>
            <p className={styles.textSmall2}>The Crowood Press, England</p>
          </div>
          <div className={styles.textBlock}>
            <div className={styles.textParagraph}>
              <p className={styles.textBig4}>The Ceramic Surface</p>
              <p className={styles.textSmall1}>by Matthias Ostermann</p>
            </div>
            <p className={styles.textSmall2}>A&C Black, London</p>
          </div>
        </div>
        <img alt={1} className={styles.photoVer} src={photo} />
      </div>
      <Navigation />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Veroffentlichungen.js